@let config = $config();
@let options = $options();

@if (config.searchable !== false) {
  <w-search
    class="sp-picker-search"
    [class.sp-picker-search-borderless]="$isCommandPalette()"
    size="Medium"
    placeholder="Search..."
    role="combobox"
    [attr.aria-activedescendant]="$activeDescendantId()"
    (search)="onSearch($event)"
    (keydown)="onSearchKeydown($event)" />
}

@if (options.length === 0) {
  <empty-message [icon]="config.emptyIcon ?? 'fa-regular fa-list'" [message]="config.emptyMessage ?? 'No options available'" iconSize="30px" />
} @else {
  <div class="sp-picker-list-root" [class.sp-picker-has-available-header]="$showAvailableHeader()" role="listbox" tabindex="-1">
    @if (config.mode === 'multi' && $selectedOptions().length > 0) {
      <div class="sp-picker-section-header">{{ config.selectedLabel ?? 'Selected' }}</div>
      <div class="sp-picker-selected" [class.sp-picker-reorderable]="config.reorderable" cdkDropList [cdkDropListDisabled]="!config.reorderable" (cdkDropListDropped)="onDrop($event)">
        @for (groupOption of $selectedGroupOptions(); track groupOption.option.id) {
          @if (config.reorderable) {
            <div class="sp-picker-selected-item" cdkDrag>
              <i class="fa-regular fa-grip-vertical sp-picker-drag-handle" cdkDragHandle></i>
              <wb-picker-item [content]="groupOption.content" [checked]="true" (toggle)="toggle(groupOption.option)" />
              <w-drag-placeholder *cdkDragPlaceholder />
              <div *cdkDragPreview></div>
            </div>
          } @else {
            <wb-picker-item [content]="groupOption.content" [checked]="true" (toggle)="toggle(groupOption.option)" />
          }
        }
      </div>
    }

    @if ($availableOptions().length === 0) {
      <empty-message icon="fa-regular fa-search" message="No matches found" iconSize="30px" />
    } @else {
      @if ($showAvailableHeader()) {
        <div class="sp-picker-section-header">{{ config.availableLabel ?? 'Available' }}</div>
      }
      <div class="sp-picker-list">
        @for (group of $groups(); track group.label ?? '_') {
          @if (group.label) {
            <div class="sp-picker-group-header">{{ group.label }}</div>
          }
          @for (groupOption of group.options; track groupOption.option.id) {
            <wb-picker-item [content]="groupOption.content" [checked]="isSelected(groupOption.option)" (toggle)="toggle(groupOption.option)" />
          }
        }
      </div>
    }
  </div>
}
